import {
	PRODUCT_TYPE_CAR,
	PRODUCT_TYPE_MOBILE,
	PRODUCT_NAME_DEVICES,
} from "@/constants/productTypes";
import type { AppData } from "@/store/appStore";

/**
 * Returns a single product type based on appData.
 * Used where only one product type should be considered.
 */
export function getEffectiveProductType(appData: AppData): ProductType {
	if (!appData) return PRODUCT_TYPE_CAR;

	// First, respect config: if only one product type is enabled, use that.
	// Config takes precedence over the user-selected onboardingCompletionType.
	if (appData.showCar && !appData.showDevice) {
		return PRODUCT_TYPE_CAR;
	}
	if (appData.showDevice && !appData.showCar) {
		return PRODUCT_TYPE_MOBILE;
	}

	// If both are enabled (toggle is shown), onboardingCompletionType drives selection.
	if (appData.showCar && appData.showDevice) {
		return appData.onboardingCompletionType === PRODUCT_NAME_DEVICES
			? PRODUCT_TYPE_MOBILE
			: PRODUCT_TYPE_CAR;
	}

	// Final fallback
	return appData.showDevice ? PRODUCT_TYPE_MOBILE : PRODUCT_TYPE_CAR;
}

/**
 * Returns a list of allowed product types.
 * Used when both "car" and "mobile" types can be valid together.
 */
export function getAllowedProductTypes(appData: AppData): ProductType[] {
	// If toggle is shown, allow both product types
	if (appData.showCar && appData.showDevice) {
		return [PRODUCT_TYPE_CAR, PRODUCT_TYPE_MOBILE];
	} else {
		// Else return only the enabled one
		if (appData.showCar) return [PRODUCT_TYPE_CAR];
		if (appData.showDevice) return [PRODUCT_TYPE_MOBILE];
	}

	return [PRODUCT_TYPE_CAR, PRODUCT_TYPE_MOBILE];
}
